import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { queryClient, QUERY_KEYS, QUERY_PREFIX } from '@src/query';
import { getMediaCarousel, getMedia } from './api';

/**
 * Find products linked to any media
 */
export const useQueryMediaCarousel = (mediaId: string) => {
  const query = useQuery({
    queryKey: [QUERY_PREFIX.MEDIA_CAROUSEL, mediaId],
    queryFn: async () => getMediaCarousel(mediaId),
  });

  useEffect(() => {
    if (query.data) {
      query.data.forEach((carouselMedia) => {
        if (carouselMedia._id === mediaId) {
          // do not prefetch the current media as it's already cached
          return;
        }
        queryClient.prefetchQuery({
          queryKey: QUERY_KEYS.media(carouselMedia._id),
          queryFn: () => getMedia(carouselMedia._id),
        });
      });
    }
  }, [query.data, mediaId]);

  return query;
};
